<template>
    <div class="hedge-adjust">
      <h1>Ajuste de Posições Futuras</h1>
      <form @submit.prevent="formSubmit">
        
        <!-- BLOCO SHORT -->
        <div class="section-block">
          <h3>Short (Hedge)</h3>
          <div class="form-row">
            <div class="form-group">
              <label>Preço de Entrada:</label>
              <input type="number" v-model.number="formData.short.price" required step="0.1" min="0" />
            </div>
            <div class="form-group">
              <label>Quantidade (BTC):</label>
              <input type="number" v-model.number="formData.short.qty" required step="0.0001" min="0" />
            </div>
          </div>
        </div>
  
        <!-- BLOCO LONG -->
        <div class="section-block">
          <h3>Long (Futuros)</h3>
          <div class="form-row">
            <div class="form-group">
              <label>Preço de Entrada:</label>
              <input type="number" v-model.number="formData.long.price" required step="0.1" min="0" />
            </div>
            <div class="form-group">
              <label>Quantidade (BTC):</label>
              <input type="number" v-model.number="formData.long.qty" required step="0.0001" min="0" />
            </div>
          </div>
        </div>
  
        <button type="submit" class="btn-submit">Salvar Alterações</button>
      </form>
    </div>
  </template>
  
  <script>
  export default {
    name: 'adjustHedgeForm',
    data() {
      const futuresInfos = this.$store.state.futuresInfos || {};
  
      return {
        formData: {
          short: {
            price: futuresInfos.short?.price ?? 0,
            qty:   futuresInfos.short?.qty   ?? 0
          },
          long: {
            price: futuresInfos.long?.price ?? 0,
            qty:   futuresInfos.long?.qty   ?? 0
          }
        }
      }
    },
    methods: {
      formSubmit() {
        const req = {
          type: 'adjustHedge',
          futuresData: this.formData
        };
        this.$store.state.socket.send(JSON.stringify(req));
      }
    }
  }
  </script>
  
  <style scoped>
  .hedge-adjust {
    width: 550px;
    padding: 15px;
  }
  .section-block {
    background: #1e1e1e;
    padding: 12px;
    border-radius: 6px;
    margin-bottom: 15px;
  }
  .form-row {
    display: flex;
    gap: 15px;
  }
  .form-group {
    flex: 1;
  }
  .btn-submit {
    width: 100%;
    padding: 10px;
    background: #26a69a;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
  }
  </style>